export default [
  {
    path: "/wt-turn-draw/:code",
    name: "TurnDraw",
    meta: {
      title: "大转盘"
    },
    component: () =>
      import(
        /* webpackChunkName: "turn-draw" */ "@/views/draw/TurnDrawPage.vue"
      )
  },
  {
    path: "/wt-golden-eggs-draw/:code",
    name: "GoldenEggsDraw",
    meta: {
      title: "砸金蛋"
    },
    component: () =>
      import(
        /* webpackChunkName: "golden-eggs-draw" */ "@/views/draw/GoldenEggsDrawPage.vue"
      )
  },
  {
    path: "/wt-red-package-draw/:code",
    name: "RedPackageDraw",
    meta: {
      title: "开红包"
    },
    component: () =>
      import(
        /* webpackChunkName: "red-package-draw" */ "@/views/draw/RedPackageDrawPage.vue"
      )
  },
  {
    path: "/wt-gird-view-draw/:code",
    name: "GirdViewDrawPage",
    meta: {
      title: "宫格抽奖"
    },
    component: () =>
      import(
        /* webpackChunkName: "gird-view-draw" */ "@/views/draw/GirdViewDrawPage.vue"
      )
  },
  {
    path: "/wt-flop-draw/:code",
    name: "FlopDrawPage",
    meta: {
      title: "翻牌"
    },
    component: () =>
      import(
        /* webpackChunkName: "flop-draw" */ "@/views/draw/FlopDrawPage.vue"
      )
  },
  {
    path: "/wt-draw/:code",
    name: "DrawEntry",
    meta: {},
    component: () =>
      import(/* webpackChunkName: "flop-draw" */ "@/views/draw/DrawEntry.vue")
  }
];
